export interface ReviveHoldState {
  /** E ainda pressionado. */
  held: boolean;
  /** Inventário, fabricação, mascate ou Carranca abertos. */
  panelOpen: boolean;
  /** O ponteiro estava travado ao começar e agora não está (Esc). */
  unlocked: boolean;
  /** Quem revive morreu. */
  dead: boolean;
}

/** Segurar E na Cruz para quando qualquer uma destas acontece (o servidor confere a distância). */
export function stopReviving(s: ReviveHoldState): boolean {
  return !s.held || s.panelOpen || s.unlocked || s.dead;
}
